import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RouterExtService } from '../../../../app/services/router-ext.service';

export type BackButtonStrategy = 'disabled' | 'previousUrl' | 'staticUrl';

@Component({
    selector: 'app-page-header-title',
    templateUrl: './page-header-title.component.html',
    styleUrls: ['./page-header-title.component.scss'],
    standalone: false,
})
export class PageHeaderTitleComponent {
    @Input() title = '';
    @Input() subtitle = '';
    @Input() backStrategy: BackButtonStrategy = 'disabled';
    @Input() backUrl = '/';

    constructor(private router: Router, private routerExt: RouterExtService) {}

    public backHandler(): void {
        let url;

        switch (this.backStrategy) {
            case 'previousUrl':
                url = this.routerExt.getPreviousUrl();
                /* fallback to default static url if previousUrl is null */
                if (url === null) {
                    url = this.backUrl;
                }
                break;
            case 'staticUrl':
                url = this.backUrl;
                break;
            case 'disabled':
                throw new Error('Called the back handler in disabled state');
            default:
                throw new Error('Called the back handler with invalid strategy');
        }

        this.router.navigateByUrl(url);
    }
}
